import { createAction } from '@reduxjs/toolkit';
import { SessaoState } from './sessaoTypes';

export const loginAction = createAction<SessaoState>('CLIENTE/LOGIN');
export const logoutAction = createAction('CLIENTE/LOGOUT');
